import React, { memo, useState, useMemo, useEffect } from 'react'
import {
  Typography,
  Button,
  Divider,
  Box,
  Stack,
  IconButton,
  List,
  ListItem,
  ListItemText
} from '@mui/material'
import { useSelector, useDispatch, } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close';
import {
  Edit as EditIcon,
  Save as SaveIcon,
  Folder as FolderIcon,
} from '@mui/icons-material';
import SimpleAdd from 'src/components/SimpleAdd';
import { arrProps as arrPropsWork } from '../work/WorkEdit';
import { getWorkById, updateWorkById, } from '../../api/work'
import * as actions from '../../reducers/form';
import { set as setAutocomplite, } from '../../reducers/autocomplite'
import validateProps from '../../functions/validateProps'
import { enqueueSnackbar } from '../../reducers/notifier'
import { arrProps } from '../material/add/MaterialUpdate';
import * as api from '../../api/material'
import { fetchDispath } from '../../functions/fetch'
import { blue, green } from '@mui/material/colors';

function GroupTableDialog({ selectedItem, handleClose, idProject, loadGroup }) {
  const obj = useSelector(state => state.formTable?.groupResEstimate?.byId[selectedItem])
  if (obj) return <EditRowNew selectedItem={selectedItem} handleClose={handleClose} obj={obj} idProject={idProject} loadGroup={loadGroup} />
  else return null
}
export default memo(GroupTableDialog)

const VIEW_FIELDS = [
  { label: 'Название', field: 'name' },
  { label: 'Тип, марка', field: 'typeMark' },
  { label: 'Артикул ', field: 'vendorCode' },
  { label: 'Единица хранения', field: 'storageUnit' },
  { label: 'Количество', field: 'count' },
  { label: 'Цена', field: 'price' },
  { label: 'Сумма', field: 'summ' },
];

function EditRowNew({ selectedItem, handleClose, obj, idProject, loadGroup }) {
  const groupResEstimate = useSelector((state) => state.formTable?.groupResEstimate?.byId);
  const groupEstimate = useSelector((state) => state.formTable?.groupEstimate?.byId);
  const groups = useMemo(() => {
    if (!groupResEstimate) return [];
    const groupIds = Object.values(groupResEstimate)
      .filter((item) => item.idMP === obj.idMP)
      .map((item) => item.idGroup);
    return groupIds
      .map((groupId) => {
        const group = Object.values(groupEstimate).find(
          (g) => g.id === groupId
        );
        return group?.name;
      })
  }, [obj.idMP, groupResEstimate, groupEstimate]);
  const [isEditing, setIsEditing] = useState(false);
  const handleCancel = () => {
    setIsEditing(false);
  };
  return <Stack spacing={2} sx={{ p: 3, width: 400 }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography variant="h6">
        {isEditing ? 'Редактирование' : 'Просмотр'}
      </Typography>
      <IconButton onClick={handleClose} size="small">
        <CloseIcon />
      </IconButton>
    </Box>
    <Divider />
    {!isEditing ?
      (<Stack spacing={2}>
        <Box>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Тип
          </Typography>
          <Typography variant="body1" style={{ color: obj?.type === 'material' ? green[500] : blue[500] }}>{obj?.type === 'material' ? 'Материал' : 'Работа'}</Typography>
        </Box>
        {VIEW_FIELDS.map(({ label, field }) => (
          <Box key={field}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              {label}
            </Typography>
            <Typography variant="body1">
              {obj[field]}
            </Typography>
          </Box>
        ))}
        <Box>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Группы
          </Typography>
          <List dense disablePadding>
            {groups.map((groupName, index) => (
              <ListItem key={index} sx={{ px: 0 }}>
                <FolderIcon fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
                <ListItemText primary={groupName} />
              </ListItem>
            ))}
          </List>
        </Box>
        <Button
          variant="contained"
          startIcon={<EditIcon />}
          onClick={() => setIsEditing(true)}
          sx={{ mt: 2 }}
        >
          Редактировать
        </Button>
      </Stack>
      ) :
      (<Stack spacing={2}>
        {obj?.type === 'material'
          ? <EditMaterial idProject={idProject} id={obj.idMP} handleEditFalse={handleCancel} loadGroup={loadGroup} />
          : <EditWork idProject={idProject} id={obj.idMP} handleEditFalse={handleCancel} loadGroup={loadGroup} />}
      </Stack>)}
  </Stack>
}
function EditMaterial({ idProject, id, handleEditFalse, loadGroup }) {
  console.log(id)
  const formName = 'materialEdit'
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchDispath({
      param: {
        id: idProject,
        idMaterial: id
      },
      progress: true,
      request: api.getMaterialById,
    })).then(res => {
      dispatch(actions.formInitialize({
        name: res.get.name,
        vendorCode: res.get.vendorCode,
        typeMark: res.get.typeMark,
        number: res.get.number,
        ourCount: res.get.ourStatus.count,
        estCount: res.get.estStatus.count,
        storageUnit: res.get.storageUnit,
        price: res.get.price,
        idStorageUnit: res.get.idStorageUnit,
        idStorageUnit2: res.get.idStorageUnit2,
        manufacturer: res.get.manufacturer,
        unitWeightKg: res.get.unitWeightKg,
        note: res.get.note,
      }, { name: formName }))
      dispatch(setAutocomplite({ value: res.get.idStorageUnit + '', label: res.get.storageUnit }, { field: 'idStorageUnit' }))
    }).catch(err => console.log(err))
  }, [dispatch, id, idProject])

  const handleUpdate = () => {
    dispatch((disp, getState) => {
      const state = getState()
      const values = state.form[formName]?.values
      const isError = validateProps(arrProps, values)
      disp(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
      if (isError.check) {
        disp(enqueueSnackbar({
          message: `некорректные поля`,
          options: { variant: 'error' }
        }))
        return;
      }
      const params = {
        name: values.name,
        vendorCode: values.vendorCode,
        typeMark: values.typeMark,
        number: values.number,
        storageUnit: values.idStorageUnit,
        price: values.price,
        ourCount: values.ourCount,
        estCount: values.estCount,
        manufacturer: values.manufacturer,
        unitWeightKg: values.unitWeightKg,
        note: values.note,
      }
      disp(actions.formSubmitAPI({
        props: params,
        url: api.updateMaterial.path({
          id: idProject,
          idMaterial: id
        }),
        method: api.updateMaterial.type,
        endFunc: () => {
          handleEditFalse()
          loadGroup()
        }
      }, formName))
    })
  };
  return <>
    <Box>
      <SimpleAdd formName={formName} arr={arrProps} gridProps={{ xs: 12 }} />
    </Box>
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mt: 2 }}>
      <Button variant="outlined" onClick={handleEditFalse}>
        Отмена
      </Button>
      <Button variant="contained" startIcon={<SaveIcon />} onClick={handleUpdate}>
        Сохранить
      </Button>
    </Box>
  </>
}
function EditWork({ idProject, id, handleEditFalse, loadGroup }) {
  const formName = 'workEdit'
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchDispath({
      param: {
        id: idProject,
        idWork: id
      },
      progress: true,
      request: getWorkById,
    })).then(res => {
      dispatch(actions.formInitialize({
        name: res.get.name,
        number: res.get.number || '',
        idType: res.get.idType,
        typeE: res.get.typeE,
        idStorageUnit: res.get.idStorageUnit,
        count: res.get.count,
        price: res.get.price,
        errorValidate: {
          name: false,
          count: false,
          price: false,
          idStorageUnit: false,
          idType: false
        },
      }, { name: formName }))
      dispatch(setAutocomplite({ value: res.get.idType + '', label: res.get.typeW }, { field: 'typeWork' }))
      dispatch(setAutocomplite({ value: res.get.idStorageUnit + '', label: res.get.storageUnit }, { field: 'storageUnit' }))
    }).catch(err => console.log(err))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch, id, idProject])
  const handleUpdate = (e) => {
    dispatch((disp, getState) => {
      const state = getState()
      const values = state.form[formName]?.values
      const isError = validateProps(arrProps, values)
      disp(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
      if (isError.check) {
        disp(enqueueSnackbar({
          message: `некорректные поля`,
          options: { variant: 'error' }
        }))
        return;
      }
      const params = {
        name: values.name,
        number: values.number,
        idType: values.idType,
        count: values.count,
        price: values.price,
        idStorageUnit: values.idStorageUnit,
      }
      disp(actions.formSubmitAPI({
        props: params,
        url: updateWorkById.path({
          id: idProject,
          idWork: id
        }),
        method: updateWorkById.type,
        endFunc: () => {
          handleEditFalse()
          loadGroup()
        }
      }))
    })
  }
  return <>
    <Box>
      <SimpleAdd formName={formName} arr={arrPropsWork} gridProps={{ xs: 12 }} />
    </Box>
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mt: 2 }}>
      <Button variant="outlined" onClick={handleEditFalse}>
        Отмена
      </Button>
      <Button variant="contained" startIcon={<SaveIcon />} onClick={handleUpdate}>
        Сохранить
      </Button>
    </Box>
  </>
}